"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_grid_system_1 = require("react-grid-system");
var react_1 = require("@emotion/react");
var getCSSRules = function (theme) { return ({
    xs: {
        marginBottom: theme.gutters.xs,
    },
    sm: {
        marginBottom: theme.gutters.sm,
    },
    md: {
        marginBottom: theme.gutters.md,
    },
    lg: {
        marginBottom: theme.gutters.lg,
    },
    xl: {
        marginBottom: theme.gutters.xl,
    },
    xxl: {
        marginBottom: theme.gutters.xxl,
    },
}); };
var Row = function (props) {
    var theme = (0, react_1.useTheme)();
    var styles = getCSSRules(theme);
    var screenClass = (0, react_grid_system_1.useScreenClass)();
    var noGutters = props.noGutters, noWrap = props.noWrap, rest = __rest(props, ["noGutters", "noWrap"]);
    return ((0, jsx_runtime_1.jsx)(react_grid_system_1.Row, __assign({}, rest, { nogutter: noGutters, wrap: noWrap ? 'nowrap' : 'wrap', css: (0, react_1.css)(styles[screenClass]) }), void 0));
};
exports.default = Row;
//# sourceMappingURL=Row.js.map